import { render } from "./Electrical.vue?vue&type=template&id=3c9ffa7b&scoped=true"
import script from "./Electrical.vue?vue&type=script&lang=js"
export * from "./Electrical.vue?vue&type=script&lang=js"

import "./Electrical.vue?vue&type=style&index=0&id=3c9ffa7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9ffa7b"]])

export default __exports__